const DRAW_STYLES = {
    FILLED: 'filled',
    STROKED: 'stroked',
    BOTH: 'both'
};

export default DRAW_STYLES;
